import type { FeatureFlags } from '../../domain/models/FeatureFlags';
import type { FeatureFlagsDto } from '../dto/FeatureFlagsDto';

export function mapFeatureFlagsDto(dto: FeatureFlagsDto): FeatureFlags {
  return {
    isSoftLoginEnabled: dto.properties?.isSoftLoginEnabled ?? false,
  };
}
